import { Profile } from '~/models/Profile';
import { Session } from '~/models/Session';

export const useProfileStore = defineStore(
  'MY_SCAN_SOURCE_PROFILE_STORE',
  () => {
    const profile = ref(new Profile());

    function setProfileData(profileData: Profile) {
      profile.value = profileData;
    }

    function clearProfileData() {
      profile.value = new Profile();
    }

    function onSessionOpen(session: Session) {
      setProfileData(
        new Profile(session.name, session.lastName, session.groups, session.email),
      );
    }

    return {
      profile,
      setProfileData,
      clearProfileData,
      onSessionOpen,
      onSessionClose: clearProfileData,
    };
  },
  {
    persist: true,
  },
);
